import { render } from "./CustomizationSuspensionCalculator.vue?vue&type=template&id=5aef7322"
import script from "./CustomizationSuspensionCalculator.vue?vue&type=script&lang=js"
export * from "./CustomizationSuspensionCalculator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__